var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEyeOff(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4,
    clipPath: "url(#clip0_2428_227)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.9301 20.93C18.9358 22.4502 16.5074 23.2923 14.0001 23.3333C5.83341 23.3333 1.16675 14 1.16675 14C2.61795 11.2955 4.63074 8.9327 7.07008 7.06999M11.5501 4.94666C12.3531 4.75868 13.1753 4.66472 14.0001 4.66666C22.1667 4.66666 26.8334 14 26.8334 14C26.1252 15.3249 25.2806 16.5722 24.3134 17.7217M16.4734 16.4733C16.153 16.8172 15.7666 17.093 15.3373 17.2843C14.9079 17.4756 14.4445 17.5785 13.9745 17.5868C13.5046 17.595 13.0378 17.5086 12.602 17.3326C12.1661 17.1565 11.7703 16.8945 11.4379 16.5622C11.1055 16.2298 10.8435 15.8339 10.6675 15.3981C10.4915 14.9623 10.405 14.4955 10.4133 14.0256C10.4216 13.5556 10.5245 13.0921 10.7158 12.6628C10.9071 12.2335 11.1829 11.8471 11.5267 11.5267",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.16675 1.16666L26.8334 26.8333",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2428_227"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeOff);
export default __webpack_public_path__ + "static/media/eye-off.bc6fb281df8aff3af93856377a1f8b14.svg";
export { ForwardRef as ReactComponent };